function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "24.3617045%",
  y1: "72.8710337%",
  x2: "63.6421593%",
  y2: "39.9796521%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2F2F2",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFCFCF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "72.5161778%",
  y1: "64.8727273%",
  x2: "8.62380839%",
  y2: "22.6545455%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "2%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  stopOpacity: 0,
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "day-cloudy",
  transform: "translate(0.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#EFCC00",
  fillRule: "nonzero",
  cx: 84.5,
  cy: 49.4446841,
  r: 31.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M84,-0.0553158818 L84,10.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84,87.9446841 L84,98.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34,49.9446841 L45,49.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123,49.9446841 L134,49.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49,14.9446841 L57,22.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112,76.9446841 L120,84.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49,84.9446841 L57,76.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112,22.9446841 L120,14.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.6759917,34.9446841 C59.8900952,34.9120269 74.7864611,43.8329661 82.3604414,58.1116072 C94.8397967,50.8446293 110.55339,52.1457401 121.656555,61.3653887 C132.75972,70.5850372 136.871287,85.7459907 131.938648,99.2794764 C127.006009,112.812962 114.08701,121.816608 99.6311764,121.795541 L43.6759917,121.944684 C19.5544075,121.944684 0,102.469091 0,78.444729 C0,54.4203672 19.5544075,34.9446841 43.6759917,34.9446841 Z",
  id: "Path",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "url(#linearGradient-2)",
  fillRule: "nonzero",
  transform: "translate(99.372837, 87.180572) rotate(-74.390000) translate(-99.372837, -87.180572) ",
  cx: 99.3728371,
  cy: 87.1805719,
  rx: 34.1705349,
  ry: 34.2478481
})));

function SvgDayCloudy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "136px",
    height: "124px",
    viewBox: "0 0 136 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "day-cloudy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayCloudy);
export default __webpack_public_path__ + "static/media/day-cloudy.005047ee.svg";
export { ForwardRef as ReactComponent };